module.exports = __webpack_public_path__ + "img/bb_g3_nose-05.5586f466.svg";